import React from 'react';
import { useDispatch } from 'react-redux';
import * as ModalActions from '../../../stores/actions/modal';

export default function NoRoomAccess(): JSX.Element {
	const dispatch = useDispatch();

	const closeModal = () => {
		dispatch(ModalActions.setModalOpen(false));
	};

	return (
		<div className="info-modal no-room-access-modal">
			<div className="title-container">
				<span>You don't have access to that room</span>
			</div>

			<div className='body'>
				<span className="explanation">Make sure you have the correct permissions then try again</span>
			</div>

			<div className='footer'>
				<button className='no-room-access-btn' data-testid="no-room-access-button" onClick={() => closeModal()}>Close</button>
			</div>
		</div>
	);
}
